/**
 * @generated SignedSource<<fecb3179e28298d6761a2f87ca4b7494>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type userProfileAvailabilityFragment$data = {
  readonly hasAvailability: boolean;
  readonly sessionDuration: number;
  readonly " $fragmentType": "userProfileAvailabilityFragment";
};
export type userProfileAvailabilityFragment$key = {
  readonly " $data"?: userProfileAvailabilityFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"userProfileAvailabilityFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "userProfileAvailabilityFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasAvailability",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "sessionDuration",
      "storageKey": null
    }
  ],
  "type": "UserProfile",
  "abstractKey": null
};

(node as any).hash = "7e02ca33d95335d1293678ecd48d70b4";

export default node;
